import { Colors, Services, getServiceNameKebabCase, getServiceNameViaPoint } from '@sigma-frontend-libs/commons'
import { EReportTaskRecurrentStatus } from '@sigmasms/shared-types'

import { icons } from '@/utils'

export const service = Services['report-manager/recurrent']
export const serviceNameViaPoint = getServiceNameViaPoint(service)
export const serviceNameKebabCase = getServiceNameKebabCase(service)

export const reportManagerRecurrentStatuses = {
  [EReportTaskRecurrentStatus.active]: {
    icon: icons.check_circle_outline,
    color: Colors.success
  },
  [EReportTaskRecurrentStatus.paused]: {
    icon: icons.pause_circle_outline,
    color: Colors.warning
  },
  [EReportTaskRecurrentStatus.cancelled]: {
    icon: icons.do_not_disturb,
    color: Colors.grey
  }
}
